import { useSelector } from '@/libs/state'
import { updateUserPreferences } from '../application/update-user-preferences'
import { userPreferences$ } from '../store'
import { userPreferencesPort } from '../wiring'
import type { UserPreferencesUpdate } from '../domain/user-preferences'

const useUserPreferences = () => {
	const preferences = useSelector(() => userPreferences$.get())

	const updatePreferences = async (patch: UserPreferencesUpdate): Promise<void> => {
		const next = await updateUserPreferences(userPreferencesPort, patch)
		userPreferences$.set(next)
	}

	return { preferences, updatePreferences }
}

export { useUserPreferences }
